import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Roles } from '@monorepo/interfaces';

export interface GckUserAssignmentModel {
    gckId: string;
    userOid: string;
}

@Injectable({ providedIn: 'root' })
export class GckUserAssignmentService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = `${environment.apiConfig[0].uri}`;

    public getUsersByGck(gckId: string, role?: Roles): Observable<GckUserAssignmentModel[]> {
        const params = role ? `?role=${role}` : '';
        return this.http.get<GckUserAssignmentModel[]>(`${this.baseUrl}/gck-user-assignments/${gckId}/users${params}`);
    }

    public getGcksByUser(userOid: string): Observable<GckUserAssignmentModel[]> {
        return this.http.get<GckUserAssignmentModel[]>(`${this.baseUrl}/gck-user-assignments/users/${userOid}/gcks`);
    }

    public createAssignment(gckId: string, userOid: string): Observable<GckUserAssignmentModel> {
        return this.http.post<GckUserAssignmentModel>(`${this.baseUrl}/gck-user-assignments/${gckId}/users`, {
            userOid
        });
    }

    public deleteAssignment(gckId: string, userOid: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/gck-user-assignments/${gckId}/users/${userOid}`);
    }
}
